import {Dependencies, WindowWithGlobalBridge} from './types';

export function createBridge(di: Dependencies = {}): DeviceMessageBridge {
  const {serializer = JSON, bridge = window as WindowWithGlobalBridge} = di;

  return {
    sendMessage(message: Message): void {
      const serialized = serializer.stringify(message);
      bridge.AndroidNative?.callNative?.(serialized);
    },
  };
}

export const androidBridge = createBridge();
